export default __webpack_public_path__ + "static/service-2-a8947360265b5bf8b47ea4e8fcde28b8.webp";